import _ from 'lodash';

export default function normalizeAccessories(config) {
  const accessoriesGroups = config.ACCESSORIES;
  const steps = _.get(config, 'steps', []);
  const accessoriesFromSteps = _.find(steps, x => x.key === 'ACCESSORIES');

  if (accessoriesFromSteps) {
    return accessoriesFromSteps.categories
      .filter(({ name }) => accessoriesGroups[name])
      .map(({ name, expanded }) => ({
        id: name,
        expanded,
        options: accessoriesGroups[name]
      }));
  }

  return Object.keys(accessoriesGroups).map(key => {
    const options = accessoriesGroups[key];
    const tokens = _.split(key, '_');
    return {
      id: tokens.length > 1 ? tokens[1] : key,
      expanded: false,
      options
    };
  });
}
